import { Grid, Typography } from '@material-ui/core';
import { styles } from './notifications-title-styles';
import React from 'react';

const NotificationTitle = ({ notificationCount }: { notificationCount: number }): JSX.Element => {
  const classes = styles();

  return (
    <Grid
      container
      justifyContent='space-between'
      alignItems='center'
      className={classes.titleContainer}
    >
      <Grid item>
        <Typography className={classes.titleText}>Notifications</Typography>
      </Grid>
      <Grid item>
        <Typography className={classes.titleText} data-testid='notification-count'>
          {notificationCount}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default NotificationTitle;
